(function () {
  var CHAT_ENDPOINT = 'https://steady-puffpuff-0a7dfd.netlify.app/api/chat';
  var RATE_LIMIT_MAX = 20;
  var RATE_LIMIT_WINDOW_MS = 60 * 60 * 1000;
  var MAX_INPUT_CHARS = 500;
  var history = [];

  // --- DOM ---
  var fab, widget, messages, input, sendBtn, rateInfo, closeBtn;

  function init() {
    // FAB
    fab = document.createElement('button');
    fab.id = 'el-chat-fab';
    fab.setAttribute('aria-label', 'Chat öffnen');
    fab.innerHTML = '<span class="el-fab-bee"><svg width="36" height="36" viewBox="0 0 60 55" xmlns="http://www.w3.org/2000/svg"><ellipse cx="16" cy="18" rx="12" ry="8" fill="rgba(255,255,255,0.25)" stroke="#1a1a1a" stroke-width="1"/><ellipse cx="44" cy="18" rx="12" ry="8" fill="rgba(255,255,255,0.25)" stroke="#1a1a1a" stroke-width="1"/><ellipse cx="30" cy="32" rx="16" ry="18" fill="#f6c400" stroke="#1a1a1a" stroke-width="1.5"/><rect x="14" y="26" width="32" height="4" rx="2" fill="#1a1a1a"/><rect x="14" y="34" width="32" height="4" rx="2" fill="#1a1a1a"/><rect x="16" y="42" width="28" height="3" rx="1.5" fill="#1a1a1a"/><circle cx="30" cy="14" r="9" fill="#f6c400" stroke="#1a1a1a" stroke-width="1.5"/><circle cx="26" cy="12" r="2.5" fill="#1a1a1a"/><circle cx="34" cy="12" r="2.5" fill="#1a1a1a"/><circle cx="27" cy="11" r="0.8" fill="#fff"/><circle cx="35" cy="11" r="0.8" fill="#fff"/><line x1="26" y1="6" x2="22" y2="0" stroke="#1a1a1a" stroke-width="1.8" stroke-linecap="round"/><line x1="34" y1="6" x2="38" y2="0" stroke="#1a1a1a" stroke-width="1.8" stroke-linecap="round"/><circle cx="22" cy="0" r="1.5" fill="#1a1a1a"/><circle cx="38" cy="0" r="1.5" fill="#1a1a1a"/><path d="M26 16 Q30 20 34 16" fill="none" stroke="#1a1a1a" stroke-width="1.2" stroke-linecap="round"/><path d="M30 50 L28 54 L32 54 Z" fill="#1a1a1a"/></svg></span>';

    // Widget
    widget = document.createElement('div');
    widget.id = 'el-chatbot-widget';
    widget.classList.add('el-hidden');
    // Unsichtbar ab der ersten Sekunde: das Stylesheet lädt verzögert, bis dahin wäre das Fenster offen
    widget.style.opacity = '0'; widget.style.pointerEvents = 'none';
    widget.innerHTML =
      '<div class="el-chat-header">' +
        '<div class="el-chat-title">emBee 🐝 <span style="font-size:11px;font-weight:500;margin-left:6px;">KI-Assistent</span></div>' +
        '<button id="el-chat-close" aria-label="Chat schließen">×</button>' +
      '</div>' +
      '<div id="el-chat-messages"></div>' +
      '<div id="el-chat-rate-info"></div>' +
      '<div class="el-chat-footer">' +
        '<textarea id="el-chat-input" placeholder="Frag emBee…" maxlength="' + MAX_INPUT_CHARS + '" rows="1"></textarea>' +
        '<button id="el-chat-send" aria-label="Senden">' +
          '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14M12 5l7 7-7 7"/></svg>' +
        '</button>' +
      '</div>';

    document.body.appendChild(fab);
    document.body.appendChild(widget);

    messages  = document.getElementById('el-chat-messages');
    input     = document.getElementById('el-chat-input');
    sendBtn   = document.getElementById('el-chat-send');
    rateInfo  = document.getElementById('el-chat-rate-info');
    closeBtn  = document.getElementById('el-chat-close');

    addMessage('bot', 'Hallo! Ich bin emBee, der KI-Assistent von embeeLAB. Ich antworte automatisch und bin keine echte Person. Frag mich alles rund um 3D-Drucke, Materialien und unseren Shop!');

    fab.addEventListener('click', toggleWidget);
    closeBtn.addEventListener('click', toggleWidget);
    sendBtn.addEventListener('click', sendMessage);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
    });
    input.addEventListener('input', autoResize);

    // Mobile: Auto-Hide beim Scrollen + Wiggle-Intro nach 3 Sek
    setupMobileBehavior();
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function setupMobileBehavior() {
    if (!isMobileViewport()) return;

    // Der Button sitzt unten rechts und ueberdeckte dort beim Laden den
    // "100%"-Vertrauensbadge im Hero. Deshalb startet er auf Mobil versteckt
    // und erscheint erst, wenn der Besucher scrollt. Der erste Bildschirm
    // bleibt so frei, ohne dass am Layout gedreht werden muss.
    var wurdeGezeigt = false;

    function fabZeigen() {
      if (wurdeGezeigt || !fab) return;
      wurdeGezeigt = true;
      fab.classList.remove('el-fab-hidden');
      wiggleIntro();
    }

    // Auf Seiten, die zu kurz zum Scrollen sind, gaebe es sonst nie einen
    // Ausloeser. Dort direkt zeigen.
    function seiteScrollbar() {
      return document.documentElement.scrollHeight > window.innerHeight + 80;
    }

    if (fab && seiteScrollbar() && window.scrollY <= 80) {
      fab.classList.add('el-fab-hidden');
    } else {
      fabZeigen();
    }

    // Auto-Hide beim Scrollen nach unten, wieder zeigen bei Stillstand
    var lastScrollY = window.scrollY;
    var hideTimer = null;
    window.addEventListener('scroll', function () {
      if (!isMobileViewport() || !fab) return;
      var current = window.scrollY;

      if (!wurdeGezeigt) {
        if (current > 80) fabZeigen();
        lastScrollY = current;
        return;
      }

      var diff = current - lastScrollY;
      if (diff > 4 && current > 80) {
        fab.classList.add('el-fab-hidden');
      }
      lastScrollY = current;
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        if (fab) fab.classList.remove('el-fab-hidden');
      }, 700);
    }, { passive: true });

    // Wiggle-Intro einmal pro Session, aber erst wenn der Button sichtbar ist
    function wiggleIntro() {
      try {
        if (sessionStorage.getItem('el-chat-fab-introduced')) return;
        setTimeout(function () {
          if (!fab || !isMobileViewport()) return;
          fab.classList.add('el-fab-wiggle');
          sessionStorage.setItem('el-chat-fab-introduced', '1');
          setTimeout(function () { if (fab) fab.classList.remove('el-fab-wiggle'); }, 900);
        }, 1200);
      } catch (e) { /* sessionStorage evtl. nicht verfügbar */ }
    }
  }

  function toggleWidget() {
    widget.style.opacity = ''; widget.style.pointerEvents = '';
    widget.classList.toggle('el-hidden');
    if (!widget.classList.contains('el-hidden')) {
      // Auto-Focus nur auf Desktop - auf Mobile springt sonst sofort die Tastatur auf
      if (!isMobileViewport()) {
        input.focus();
      }
    }
  }

  function renderText(text) {
    var escaped = String(text).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    // Markdown links [Text](/url) → <a>
    // Nur interne Ziele verlinken (kein "//fremde-domain", keine Sonderzeichen), sonst nur Text
    escaped = escaped.replace(/\[([^\]]+)\]\((\/[^)]*)\)/g, function(_, label, href) {
      if (!/^\/(?!\/)[a-z0-9\-\/#]*$/i.test(href)) return label;
      return '<a href="' + href + '" target="_blank" rel="noopener noreferrer" style="color:#f6c400;text-decoration:underline;text-underline-offset:2px;">' + label + '</a>';
    });
    // Bare paths /pages/xxx oder /collections/xxx → <a>
    escaped = escaped.replace(/(?<![="\/])(\/(?:pages|collections)\/[a-z0-9_-]+)/g, function(_, path) {
      return '<a href="' + path + '" target="_blank" rel="noopener noreferrer" style="color:#f6c400;text-decoration:underline;text-underline-offset:2px;">' + path + '</a>';
    });
    return escaped;
  }

  function addMessage(role, text) {
    var msg = document.createElement('div');
    msg.className = 'el-chat-msg el-chat-msg--' + role;
    if (role === 'bot') {
      msg.innerHTML = renderText(text);
    } else {
      msg.textContent = text;
    }
    messages.appendChild(msg);
    messages.scrollTop = messages.scrollHeight;
    return msg;
  }

  function autoResize() {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 90) + 'px';
  }

  // --- Rate Limiting (sessionStorage) ---
  function getRateData() {
    try {
      return JSON.parse(sessionStorage.getItem('el_rl') || '{}');
    } catch (e) { return {}; }
  }

  function isRateLimited() {
    var d = getRateData();
    if (!d.w) return false;
    if (Date.now() - d.w > RATE_LIMIT_WINDOW_MS) return false;
    return d.c >= RATE_LIMIT_MAX;
  }

  function incrementRate() {
    var d = getRateData();
    var now = Date.now();
    if (!d.w || now - d.w > RATE_LIMIT_WINDOW_MS) {
      d = { c: 1, w: now };
    } else {
      d.c = (d.c || 0) + 1;
    }
    sessionStorage.setItem('el_rl', JSON.stringify(d));
  }

  function getRemainingCount() {
    var d = getRateData();
    if (!d.w || Date.now() - d.w > RATE_LIMIT_WINDOW_MS) return RATE_LIMIT_MAX;
    return Math.max(0, RATE_LIMIT_MAX - (d.c || 0));
  }

  // --- Send ---
  function sendMessage() {
    var text = input.value.trim();
    if (!text) return;

    if (isRateLimited()) {
      rateInfo.style.display = 'block';
      rateInfo.textContent = 'emBee braucht kurz Pause - du hast das Limit von ' + RATE_LIMIT_MAX + ' Nachrichten/Stunde erreicht.';
      return;
    }

    history.push({ role: 'user', content: text });
    addMessage('user', text);
    input.value = '';
    input.style.height = 'auto';
    sendBtn.disabled = true;

    var loadingMsg = addMessage('bot el-chat-msg--loading', '🐝 …');

    incrementRate();

    var remaining = getRemainingCount();
    if (remaining <= 3) {
      rateInfo.style.display = 'block';
      rateInfo.textContent = 'Noch ' + remaining + ' Nachricht' + (remaining === 1 ? '' : 'en') + ' in dieser Stunde.';
    }

    fetch(CHAT_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: history })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var reply = data.reply || data.error || 'Ups, da ist etwas schiefgelaufen.';
        history.push({ role: 'assistant', content: reply });
        loadingMsg.className = 'el-chat-msg el-chat-msg--bot';
        loadingMsg.innerHTML = renderText(reply);
        messages.scrollTop = messages.scrollHeight;
      })
      .catch(function () {
        loadingMsg.className = 'el-chat-msg el-chat-msg--bot';
        loadingMsg.textContent = '🐝 Ich bin gerade nicht erreichbar. Bitte versuch es später nochmal!';
        messages.scrollTop = messages.scrollHeight;
      })
      .finally(function () {
        sendBtn.disabled = false;
        input.focus();
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
